import React from 'react';
import Select from 'react-select';
import _ from 'lodash-es';

import { ReactComponent as LeftArrow } from '../../../../../../assets/images/CalendarLeftArrow.svg';
import { ReactComponent as RightArrow } from '../../../../../../assets/images/CalendarRightArrow.svg';

import styles from './CustomHeader.module.scss';

const years = _.range(1995, new Date().getFullYear() + 1).map((year, idx) => ({ id: idx, value: year, label: year }));
const months = [
  { id: 0, value: 'January', label: 'January' },
  { id: 1, value: 'February', label: 'February' },
  { id: 2, value: 'March', label: 'March' },
  { id: 3, value: 'April', label: 'April' },
  { id: 4, value: 'May', label: 'May' },
  { id: 5, value: 'June', label: 'June' },
  { id: 6, value: 'July', label: 'July' },
  { id: 7, value: 'August', label: 'August' },
  { id: 8, value: 'September', label: 'September' },
  { id: 9, value: 'October', label: 'October' },
  { id: 10, value: 'November', label: 'November' },
  { id: 11, value: 'December', label: 'December' },
];

const customStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #E9F9F1',
    fontWeight: '500',
    textAlign: 'left',
    boxShadow: 'none',
    '&:hover': { border: '1px solid #0FBC72' },
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#E9F9F1' : '#FFFFF',
    color: '#343741',
  }),
};

const CustomHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => (
  <div className={styles.headerContainer}>
    <button className={styles.arrowBtn} type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
      <LeftArrow />
    </button>
    <Select
      className={styles.dropdown}
      options={months}
      value={months[date.getMonth()]}
      onChange={(month) => changeMonth(month.id)}
      components={{
        IndicatorSeparator: () => null,
      }}
      styles={customStyles}
    />
    <Select
      className={styles.dropdown}
      options={years}
      value={years.find((year) => year.value === date.getFullYear())}
      onChange={(year) => changeYear(year.value)}
      components={{
        IndicatorSeparator: () => null,
      }}
      styles={customStyles}
    />
    <button className={styles.arrowBtn} type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
      <RightArrow />
    </button>
  </div>
);

export default CustomHeader;
